import React, { useState, useEffect } from 'react';
import korrectLogo from '../../assets/images/korrectLogoIcon.png';
import CueProduct from './CueManager/cast_cue _product';
import CueSeries from './CueManager/cast_cue_series';
import CueSong from './CueManager/cast_cue_song';
import Cue from './CueManager/cast_cue';
import metaDataServices from './MetaDataServices';
import ProductionLanding from './ProductionManager/ProductionLand';
import PerformerLanding from './PerformerManager/PerformerLanding';
import CastLanding from './CastsManager/CastLanding';
import Agrements from './Agrements';
import Income from './Income';

export default function MetaDataMainUI(subEntity: any) {

    let [activeSubTab, setactiveSubTab] = useState("Production");
    let [activeMenu, setActiveMenu] = useState("Production");

    useEffect(() => {

        metaDataServices.cueSheetTypelistSearch().then((res: any) => {
            global.cueSheetType = res;
        })

        metaDataServices.statusProductList({ pageNumber: 1, pageSize: 100 }).then((res: any) => {
            global.statusProduct = res;
        })

        metaDataServices.statusProductExtList({ pageNumber: 1, pageSize: 100 }).then((res: any) => {
            global.statusProductExt = res;
        })


    }, [subEntity])

    const menu = [
        { label: 'Menu', value: 'Production' },
        { label: 'Menu', value: 'Performer' },
        { label: 'Menu', value: 'Cast' },
        { label: 'Menu', value: 'Cue' },
    ];

    const closeModal = (e: any) => {
        const modal = document.getElementById("myModal") as HTMLElement;
        modal?.classList.remove("displayItem");
        modal?.classList.add("displayNoneItem");
        document.body.classList.remove("HiddenoverflowX");
    }

    const onChangeMenu = (e: any) => {

        if (e == "Cast") {
            activeSubTab = "castListing"
            setactiveSubTab(activeSubTab)
        } else if (e == "Cue") {
            activeSubTab = "cueListing"
            setactiveSubTab(activeSubTab)
        } else if (e == "Production") {
            activeSubTab = "Production"
            setactiveSubTab(activeSubTab)
        } else {

            activeSubTab = e
            setactiveSubTab(activeSubTab)
        }

        console.log(e)
        setActiveMenu(e)
    }


    const onChangeSelectMenu = (e: any) => {
        console.log(e)

        onChangeMenu(e)
    }

    return (<>

        {(subEntity) && <div id="myModal" className="modal pLarge ws-12 ">

            <a onClick={() => closeModal(true)} className="btn-xxs modalClose borderNone bgTransparent" style={{ position: "inherit" }} href="../../">
                <i className="icon-close3 danger"></i>
            </a>

            <div className="allowHscroll allowVscroll full-height-vh95 ws-12 box" style={{ minHeight: "80%" }}>
                <div className="12">
                    <div className="ws-2 pm borderReset full-height pLarge">
                        <div className="ws-12 text-center pLarge mtll mbl">
                            <img className="pull-none" src={korrectLogo} width={50} />
                        </div>

                        <ul className="main-menu pll prl ws-12">
                            <a className="full-width text-bold text-average text-m mtl ws-12 pbl">Production</a>
                            <ul >
                                {menu?.map((value: any) => {
                                    return (<>
                                        {<li key={value.title} className={activeMenu === value.value ? " active" : ""}>
                                            <a className={"ws-12 text-sl text-normal"} onClick={() => { onChangeMenu(value.value) }}> {value.value}s </a>
                                        </li>}
                                    </>)
                                })}
                            </ul>

                            <hr style={{ "borderTop": "solid 2px #E3E6EC !important", "marginTop": "50px" }}></hr>
                            <ul >
                                <li className={activeMenu === "Agreements" ? " active ws-12" : " ws-12"}>
                                    <a className={"ws-12 text-sl text-normal"} onClick={() => { onChangeMenu('Agreements') }}>
                                        <i className='icon-Grid_Approval text-m mr'></i>
                                        Members Agreements </a>
                                </li>
                                <li className={activeMenu === "Income" ? " active ws-12" : " ws-12"}>
                                    <a className={"ws-12 text-sl text-normal"} onClick={() => { onChangeMenu('Income') }}>
                                        <i className='icon-currency-dollar text-m mr' ></i> Income Sources
                                    </a>
                                </li>

                            </ul>

                        </ul>
                    </div>

                    <div className="ws-10 pr pm landing">
                        <div className='ws-12 pll'>
                            <div className="ws-12 ptxl">
                                <span className="ws-12 text-bold text-xl"> {activeMenu} Manager</span>
                                <span className="ws-12 ptl text-bold text-m turquoise">{activeMenu}</span>
                            </div>

                            {/*            {(activeMenu == "Cast Manager") && <ul className="nav nav-tabs nav-justified ws-12">
                                    {<a onClick={() => { setactiveSubTab("castListing"); }} className={activeSubTab === "castListing" ? "btn-success active" : "btn-success"}>Cast</a>}
                                    {<a onClick={() => { setactiveSubTab("castProductListing"); }} className={activeSubTab === "castProductListing" ? "btn-success active" : "btn-success"}>Cast Product</a>}
                                    {<a onClick={() => { setactiveSubTab("castSeriesListing"); }} className={activeSubTab === "castSeriesListing" ? "btn-success active" : "btn-success"}>Cast Series</a>}
                                    {<a onClick={() => { setactiveSubTab("castSongsListing"); }} className={activeSubTab === "castSongsListing" ? "btn-success active" : "btn-success"}>Cast Songs  </a>}
                                </ul>} */}

                            {(activeMenu == "Cue") && <ul className="nav nav-tabs nav-justified ws-12 m0 p0 mtl mbl">
                                {<a onClick={() => { setactiveSubTab("cueListing"); }} className={activeSubTab === "cueListing" ? "btn-success active" : "btn-success"}>Cue</a>}
                                {<a onClick={() => { setactiveSubTab("CueProductListing"); }} className={activeSubTab === "CueProductListing" ? "btn-success active" : "btn-success"}>Cue Product</a>}
                                {<a onClick={() => { setactiveSubTab("cueSeriesListing"); }} className={activeSubTab === "cueSeriesListing" ? "btn-success active" : "btn-success"}>Cue Series</a>}
                                {<a onClick={() => { setactiveSubTab("cueSongsListing"); }} className={activeSubTab === "cueSongsListing" ? "btn-success active" : "btn-success"}>Cue Songs  </a>}
                            </ul>}

                            <div className='ws-12'>
                                {/*              {(activeSubTab === "castListing") && <Cast activeSubTab={activeSubTab} />}
                                    {(activeSubTab === "castProductListing") && <CastProduct activeSubTab={activeSubTab} />}
                                    {(activeSubTab === "castSeriesListing") && <CastSeries activeSubTab={activeSubTab} />}
                                    {(activeSubTab === "castSongsListing") && <CastSong activeSubTab={activeSubTab} />} */}


                                {(activeMenu === "Production") && <ProductionLanding activeSubTab={activeSubTab} onChangeSelectMenu={onChangeSelectMenu} />}
                                {(activeMenu === "Performer") && <PerformerLanding activeSubTab={activeSubTab} onChangeSelectMenu={onChangeSelectMenu} />}
                                {(activeMenu === "Agreements") && <Agrements activeSubTab={activeSubTab} onChangeSelectMenu={onChangeSelectMenu} />}
                                {(activeMenu === "Income") && <Income activeSubTab={activeSubTab} onChangeSelectMenu={onChangeSelectMenu} />}


                                {(activeSubTab === "cueListing") && <Cue activeSubTab={activeSubTab} onChangeSelectMenu={onChangeSelectMenu} />}
                                {(activeSubTab === "CueProductListing") && <CueProduct activeSubTab={activeSubTab} onChangeSelectMenu={onChangeSelectMenu} />}
                                {(activeSubTab === "cueSeriesListing") && <CueSeries activeSubTab={activeSubTab} onChangeSelectMenu={onChangeSelectMenu} />}
                                {(activeSubTab === "cueSongsListing") && <CueSong activeSubTab={activeSubTab} onChangeSelectMenu={onChangeSelectMenu} />}
                                {(activeMenu === "Cast") && <CastLanding activeSubTab={activeSubTab} onChangeSelectMenu={onChangeSelectMenu} />}
                            </div>


                        </div>
                    </div>

                </div>
            </div>

        </div>}
    </>
    )
}